<template>
  <div>
    <validation-observer ref="tvForm">
      <b-card title="TV-Kabelanschluss">
        <validation-provider
            #default="{ errors }"
            name="TV Anschluss"
            vid="tv-active"
            :rules="{ required: { allowFalse: false } }"
        >
          <div v-for="serviceOption in SERVICE.serviceOptions" :key="serviceOption.id">
            <div
                v-if="serviceOption.description.toLowerCase().indexOf('kabel') > -1">
              <service-options-group
                  :service-option="serviceOption"
                  type="radio"
                  :show-title="false"
                  model-key="tvServiceOption"
                  additional-text=" / Kein Bereitstellungsentgelt bei Online-Buchung."
                  :add-minimum-term-period="true"
                  :reset-button="true"
                  @input="hasTvOption"
              />
            </div>
          </div>

          <p class="mt-1" v-if="getChannelListDocumentUrl">
            Ein Übersicht der verfügbaren Sender können Sie <a :href="getChannelListDocumentUrl()" target="_blank">HIER</a> einsehen.
          </p>

          <b-form-group v-if="false" label="TV Kabelanschluss buchen" label-for="tv-active" class="required">
            <b-form-radio-group v-model="CHECKOUT_DATA.tv">
              <b-form-radio value="1">
                Ja
              </b-form-radio>
              <b-form-radio value="0">
                Nein
              </b-form-radio>
            </b-form-radio-group>

            <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>

        <div v-if="CHECKOUT_DATA.tv == 'Ja'">
          <b-alert
              variant="warning"
              show
              v-if="showInfoBlock && false"
          >
            <div class="alert-body">
              <p><strong>Info für Cable 4</strong></p>
              <div>
                Es existiert bisher kein Produkt zum TV-Anschluss in der API
              </div>
            </div>
          </b-alert>
        </div>
      </b-card>
      <b-card title="TV-Anschluss ist bereits freigeschaltet" v-if="CHECKOUT_DATA.has_active_tv_option">
        <validation-provider
            #default="{ errors }"
            name="TV-Anschluss ist bereits freigeschaltet"
            vid="tv-active"
            :rules="{ required: { allowFalse: false } }"
        >
          <b-form-group label="TV-Anschluss ist bereits freigeschaltet" label-for="tv-free" class="required">
            <b-form-radio-group v-model="CHECKOUT_DATA.tv_free">
              <b-form-radio value="Ja">
                Ja
              </b-form-radio>
              <b-form-radio value="Nein">
                Nein
              </b-form-radio>
              <b-form-radio  value="Unbekannt">
                Unbekannt
              </b-form-radio>
            </b-form-radio-group>

            <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
          </b-form-group>
        </validation-provider>


        <b-form-group v-if="CHECKOUT_DATA.tv_free == 'Ja'" label="Namen des Vormieters" label-for="tv-previous-tenant">
          <b-form-input
              id="tv-previous-tenant"
              v-model="CHECKOUT_DATA.tv_previous_tenant"
              placeholder="Falls bekannt, geben Sie bitte den Namen des Vormieters an."
          />
        </b-form-group>
      </b-card>
    </validation-observer>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  BCol,
  BFormCheckbox, BFormGroup, BFormInput, BRow,
} from "bootstrap-vue";
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {required, email, digits} from '@validations'
import {required_if} from 'vee-validate/dist/rules';
import ServiceOptionsGroup from "@/components/ServiceOptionsGroup";

export default {
  name: "TVSection",
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BFormInput,
    ServiceOptionsGroup
  },
  data() {
    return {
      separateAccountOwner: false,
      active: false,
      hasActiveTvOption: false,
      showInfoBlock: process.env.VUE_APP_ROOT_SHOW_CABLE_4_INFO_BLOCKS
    }
  },
  computed: {
    ...mapGetters(['CHECKOUT_DATA', 'SERVICE', 'PRODUCTS']),
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(price / 100)
    },
    validateForm() {
      this.$refs.tvForm.validate()
    },
    getChannelListDocumentUrl() {
      for (let product of this.PRODUCTS) {
        if (product.name.toLowerCase().indexOf("tv-kabelanschluss") > -1) {
          for (let document of product.documents) {
            if (document.type === "SL") {
              return this.getDocumentUrl(document);
            }
          }
        }
      }
    },
    getDocumentUrl(document) {
      return process.env.VUE_APP_ROOT_API + 'document/' + document.id + '/' + this.SERVICE.tenant
    },
    hasTvOption() {
      let hasTv = false

      Object.keys(this.CHECKOUT_DATA.tvServiceOption).forEach((item) => {
        if (this.CHECKOUT_DATA.tvServiceOption[item].length > 0) hasTv = true
      })

      this.CHECKOUT_DATA.has_active_tv_option = hasTv

      return this.CHECKOUT_DATA.has_active_tv_option;
    }
  }
}
</script>

<style scoped>

</style>
